import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingRedlineRequestHelper } from './transfer-pricing-redline-request-helper';
import type {
  ITransferPricingRedlineSubject,
  ITransferPricingRedlinesResponse,
} from './types';

/** Every comparison the record has, one per consecutive version pair. Pass null to disable the
 * request entirely, the way the pages do before the record id resolves. */
export const useTransferPricingRedlines = (
  subject: ITransferPricingRedlineSubject | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingRedlinesResponse>(
      subject ? TransferPricingRedlineRequestHelper.listPath(subject) : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    redlines: data?.redlines ?? TransferPricingRedlineRequestHelper.NO_REDLINES,
    count: data?.count ?? 0,
    isLoading,
    error,
    mutate,
  };
};
